<div>
  @if(!verificationOnly) {
    <div class="title">Select the account to pay from:</div>
  } @else {
    <div class="title">Select the account to verify:</div>
  }

  @for(account of paymentMethods; track account.token) {
    <div class="account">
      @if(account.verified) {
        <div class="verified">Verified</div>
      } @else {
        <div class="verified not">Not Verified</div>
      }

      <div>Bank: <span>{{account.bankName}}</span></div>
      <div>Type: <span class="bank-type">{{account.accountType}}</span></div>
      <div>Account Last 4 digits: <span>{{account.last4}}</span></div>
      @if(account.verified) {
        <div class="action-section">
          <div class="remove" (click)="removeAccount(account.token)">Remove</div>
          <button mat-raised-button color="primary" class="full-witdh" type="button" (click)="selectAccount(account.token)" [disabled]="loading">
            PAY WITH THIS ACCOUNT
          </button>
        </div>
      } @else {
        <div class="action-section">
          @if(!verificationOnly) {
            <div class="remove" (click)="removeAccount(account.token)">Remove</div>
          } @else {
            <div></div>
          }
          <button mat-raised-button color="primary" class="full-witdh" type="button" (click)="verify(account)" [disabled]="loading">
            VERIFY ACCOUNT
          </button>
        </div>
      }
      
    </div>
  }

  @if(!paymentMethods.length && verificationOnly) {
    <div>You don't have accounts to verify.</div>
  }

</div>